import React, { useState } from 'react';
import './WorkflowRunner.css';
import mergedImage from '../assets/Merged_image.png';


// --- 1. Store the hardcoded response data for the specific agent ---
/*const policyHygieneMockResponse = {
  email: {
    subject: "Firewall Policy Optimization Week-1 Report – FortiGate| October 9, 2025 at 12:03 PM IST",
    html: `
      <p>Hi Client,</p>
      <p>As part of our ongoing efforts to enhance your network security and operational efficiency, we’ve completed a comprehensive analysis of <b>FortiGate</b> firewall rulebase.The given <b>Firewall Policy Optimization Report</b> outlines key findings and actionable recommendations.</p>
      <b>Device Description : </b>
      <ul>
        <li>Host Name: FSMEXICOFW02</li>
        <li>Model&Version: FortiGate-400F v7.4.8,build2795,250523 (GA.M)</li>
        <li>Serial Number: FG4H0FT923910347</li>
      </ul>
      <b>Executive Summary :</b>
      <ul>
        <li><b>Obsolete Firewall Rules Identified:</b>10</li>
      </ul>
      <p>These rules appear to be outdated or unused, and may be contributing to unnecessary complexity and potential security exposure.</p>
      <b>Recommendation :</b>
      <p><b>We strongly advise reviewing and removing these obsolete rules to:</b></p>
      <ul>
        <li>Strengthen your overall security posture</li>
        <li>Reduce the attack surface</li>
        <li>Improve manageability and performance of the firewall</li>
      </ul>
      <b>Detailed Findings :</b>
      <ul>
        <li>A breakdown of the undefined policies is provided in the report, including policy names, policy ID and suggested actions.</li>
      </ul>
      <style> table { width: 100%; border-collapse: collapse; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; box-shadow: 0 4px 8px rgba(0,0,0,0.1); border-radius: 8px; overflow: hidden; } th, td { padding: 12px 15px; text-align: left; border: 1px solid #dee2e6; } th { background-color: #007bff; color: white; } tr{ background-color: #f8f9fa; color:#000000; } tr:hover { background-color: #e9ecef; } </style>
      <table><thead><tr style="background-color: #007bff; color: #ffffff;"><th>PolicyName</th><th>Policy_id</th></tr></thead><tbody><tr><td>Cisco_Amp_rule (29)</td><td>29</td></tr><tr><td>Nutanix_Rule (12)</td><td>12</td></tr><tr><td>Sentinel_One_Rule (18)</td><td>18</td></tr><tr><td>FS_Corp_Site_Rule (16)</td><td>16</td></tr><tr><td>Conduent_Backup (53)</td><td>53</td></tr><tr><td>MS_Teams_Rule (36)</td><td>36</td></tr><tr><td>IT_Vlan_Internet_Rule (28)</td><td>28</td></tr><tr><td>MS_Teams_Rule (36)</td><td>36</td></tr><tr><td>IT_Vlan_Internet_Rule (28)</td><td>28</td></tr><tr><td>SMTP Access (58)</td><td>58</td></tr></tbody></table>
      <br><b>Summary of Cleanup :</b><br><br>
      <table><thead><tr style="background-color: #007bff; color: #ffffff;"><th>Metric</th><th>Value</th></tr></thead><tbody><tr><td>Total Rules Before Cleanup</td><td>241</td></tr><tr><td>Obsolete Rules Identified</td><td>10</td></tr><tr><td>Rules to be Removed</td><td>0</td></tr><tr><td>Rules Retained</td><td>10</td></tr><tr><td>Total Rules After Cleanup</td><td>241</td></tr></tbody></table>
      <br><b>Implementation Scripts :</b><br><br><pre><code>config firewall policy\n    delete 29\n    delete 12\n    delete 18\n    delete 16\n    delete 53\n    delete 36\n    delete 28\n    delete 36\n    delete 28\n    delete 58\nend</code></pre>
      <br><b>RollBack Scripts :</b><br><br><pre><code>config firewall policy\n    edit 29\n        set status enable\n    next\n    edit 12\n        set status enable\n    next\nend</code></pre>
    `
  }
};
*/
const policyHygieneMockResponse = {
  email: {
    subject: 'RunOps Firewall Hygiene Agent Dashboard — 30-Day Intelligence Overview (10 Firewalls)',
    html: `
      <div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; color: #333333; line-height: 1.6;">
        
        <h3>RunOps Firewall Hygiene Agent Dashboard — 30-Day Intelligence Overview (10 Firewalls)</h3>
        
        <h4>1. Hygiene Posture Overview</h4>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-size: 14px;">
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><th>Metric</th><th>30-Day Value</th><th>Target</th><th>Trend vs. Last 30 Days</th><th>Interpretation</th></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Overall Hygiene Score</td><td>78.4 / 100</td><td>≥ 90</td><td>▲ +14%</td><td>Progressive improvement after initial baseline cleanup.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Zero-Trust Alignment</td><td>85%</td><td>≥ 95%</td><td>▲ +6%</td><td>Strong progress in cross-zone segmentation enforcement.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Automation Adoption</td><td>42%</td><td>60%</td><td>▲ +11%</td><td>Nearly half of hygiene actions executed without manual input.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Ticket Deflection</td><td>41%</td><td>≥ 50%</td><td>▲ +9%</td><td>Clear efficiency gain in L2/L3 labor reduction.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Audit Readiness</td><td>68%</td><td>90%</td><td>▲ +8%</td><td>Evidence generation automated; governance cycle stabilizing.</td></tr>
        </table>

        <h4>2. Rulebase Composition & Risk Distribution</h4>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-size: 14px;">
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><th>Category</th><th>Count</th><th>% of Total</th><th>Commentary (L4 Insight)</th></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Active Rules</td><td>41,512</td><td>85.4%</td><td>Current active estate across 10 firewalls.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Unused Rules</td><td>4,963</td><td>10.2%</td><td>Legacy drag — scheduled for disablement.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Shadowed Rules</td><td>2,276</td><td>4.7%</td><td>Primarily overlapping NAT and duplicate address groups.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Any-Any Rules</td><td>74</td><td>0.15%</td><td>Critical exposure; all tagged and under review.</td></tr>
        </table>
        <p style="font-size: 14px;"><b>Overlay Metric:</b> Highlight rules with combined low utilization + broad service scope as <b>High Drift Candidates (512 rules)</b>.</p>

        <h4>3. Tagging, Ownership & Governance Health</h4>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-size: 14px;">
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><th>Dimension</th><th>Compliant</th><th>Non-Compliant</th><th>Commentary</th></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Owner Tag Presence</td><td>90.2%</td><td>9.8%</td><td>Missing ownership mainly in legacy imports.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Tag Format (APP_ENV_OWNER_ZONE)</td><td>95.7%</td><td>4.3%</td><td>Clean tag adoption improving post-migration.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Rules with Comments/Justifications</td><td>87.2%</td><td>12.8%</td><td>Gaps reduce audit traceability; auto-commenting in next release.</td></tr>
        </table>

        <h4>4. Threat Intelligence & Vulnerability Exposure</h4>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-size: 14px;">
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><th>Threat Metric</th><th>Count</th><th>Risk Level</th><th>Notes</th></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Rules Linked to Active IoCs</td><td>133</td><td>High</td><td>Detected via CISA KEV + CrowdStrike Intel.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Deprecated Protocols (Telnet, SMBv1, SNMPv1)</td><td>186</td><td>Medium</td><td>To be phased out per PAN advisory RH-07.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Rules Mapping to Known CVEs</td><td>47</td><td>Critical</td><td>CVE-2023-47246, CVE-2024-3400 top risks.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Outbound DNS/NTP to Unknown Hosts</td><td>19</td><td>Medium</td><td>Likely post-migration misconfigurations.</td></tr>
        </table>

        <h4>5. Automation & Agent Performance</h4>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-size: 14px;">
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><th>Metric</th><th>30-Day Result</th><th>Target</th><th>Observation</th></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Auto-Remediations Executed</td><td>2,346</td><td>—</td><td>High success rate, no failed commits.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Human-Reviewed Recommendations</td><td>3,911</td><td>—</td><td>82% approval rate by L3/L4 analysts.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Mean Time to Detect (MTTD)</td><td>3.8 min</td><td>< 5 min</td><td>Near real-time; event-driven workflow validated.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Mean Time to Remediate (MTTR)</td><td>15.2 min</td><td>< 20 min</td><td>Meets operational SLA for hygiene changes.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>API Reliability (Panorama)</td><td>99.4%</td><td>≥ 99%</td><td>API key reuse and retry logic effective.</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Agent Uptime</td><td>99.93%</td><td>≥ 99.5%</td><td>Zero missed Cron executions.</td></tr>
        </table>

        <h4>6. Compliance Alignment (Mapped Control Coverage)</h4>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-size: 14px;">
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><th>Control Domain</th><th>Coverage %</th><th>Mapped Framework</th></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Network Segmentation</td><td>87%</td><td>NIST SC-7, PCI 1.2.1</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Access Restriction</td><td>84%</td><td>ISO A.9.1.2, NIST AC-4</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Change Control Logging</td><td>76%</td><td>SOC 2 CC7.2</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Encryption Enforcement</td><td>81%</td><td>HIPAA §164.312(e)(1)</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Rule Review / Lifecycle</td><td>72%</td><td>PCI 1.1.7, NIST CM-6</td></tr>
        </table>

        <h4>7. Learning & Adaptation Analytics</h4>
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; width:100%; font-size: 14px;">
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><th>Learning KPI</th><th>30-Day Baseline</th><th>Current</th><th>Improvement</th></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Rule Hygiene Prediction Accuracy</td><td>87%</td><td>92%</td><td>▲ +5%</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Analyst Override Rejections</td><td>196</td><td>142</td><td>▼ -27%</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Explainability Score (LLM Decision Clarity)</td><td>91%</td><td>93%</td><td>▲ +2%</td></tr>
          <tr style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;"><td>Repeated Drift Detection</td><td>44</td><td>38</td><td>▼ -14%</td></tr>
        </table>

        <h4>8. Hygiene Trendline (Rolling 90-Day Projection)</h4>
        <p style="font-size: 14px;"><b>Visual:</b> Line Chart<br>
        <b>Y-Axis:</b> Average Hygiene Score<br>
        <b>X-Axis:</b> Days (0–90)<br>
        <b>Current:</b> 78.4<br>
        <b>Projected (with full automation):</b> 91.2 by Day 90<br>
        <b>Reference Lines:</b><br>
        80 = Operational Baseline<br>
        90 = Target Compliance Ready<br>
        95 = Zero-Trust Mature</p>
      </div>
    `
  }
};
const lifeCycleMockResponse = {
  email: {
    subject: "Certificate Expired For Fortigate-60D | October 9, 2025 at 12:12 PM IST",
    html: `<p>Dear Team,</p><p>The SSL Ceritficate for the model <b>FortiWiFi-60D</b> is expired. Please consider this as a priority and renew it to avoid security risks.</p><br><p><b>Description:</b><br>Host Name: Fortigate-60D,<br>Model: FortiWiFi-60D,<br>Serial: FWF60D4613003544,<br>Version: 6.0.16</p><hr><h2>Software and Hardware Support Information :</h2><h3>Hardware Details :</h3>
       <style> :root { --table-bg: #ffffff; --table-border-color: #dee2e6; --table-text-color: #212529; --table-shadow: 0 4px 8px rgba(0,0,0,0.1); --table-header-bg: #007bff; --table-header-text: #ffffff; --table-row-even-bg: #f4f4f4; --table-row-odd-bg: #ffffff; } @media (prefers-color-scheme: dark) { :root { --table-bg: #2d2d2d; --table-border-color: #555555; --table-text-color: #e0e0e0; --table-shadow: 0 4px 8px rgba(0,0,0,0.4); --table-row-even-bg: #3c3c3c; --table-row-odd-bg: #2d2d2d; } } table { width: 100%; border-collapse: collapse; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; box-shadow: var(--table-shadow); border-radius: 8px; overflow: hidden; background-color: var(--table-bg); color: var(--table-text-color); } th, td { padding: 12px 15px; text-align: left; border: 1px solid var(--table-border-color); } th { background-color: var(--table-header-bg); color: var(--table-header-text); } tr:nth-child(even) {background-color: var(--table-row-even-bg);} tr:nth-child(odd) {background-color: var(--table-row-odd-bg);} </style>
       <table><thead><tr><th>Model</th><th>EndDate</th><th>EndOfLifeSupport</th></tr></thead><tbody><tr><td>FortiWiFi-60D</td><td>05 / 08 / 2023</td><td>https://www.parkplacetechnologies.com/eosl/fortinet/fortiwifi-60d/</td></tr></tbody></table>
       <h3>Software Support Details :</h3>
       <table><thead><tr><th>LatestMajorVersion</th><th>CurrentVersion</th><th>VersionStatus</th></tr></thead><tbody><tr><td>7.6</td><td>6.0.16</td><td>You are N-6 versions back from the current latest version (7.6.x)</td></tr></tbody></table>
       <br><b>Attached below the Detailed List of Items:</b><br><br>
       <table style="width: 100%; border-collapse: collapse; font-family: Arial, sans-serif;"><thead><tr><th>Category</th><th>Licenses</th></tr></thead><tbody>
       <tr><td><strong>Expired</strong></td><td>
         <table style="width: 100%; border-collapse: collapse;"><thead><tr><th>Name</th><th>Version</th><th>Contract Expiry Date</th><th>Expired Ago</th></tr></thead><tbody>
         <tr style="background-color: #E57373; color: #ffffff;"><td>AV Engine</td><td>6.00033</td><td>Tue May  9 2023</td><td>884</td></tr>
         <tr style="background-color: #E57373; color: #ffffff;"><td>Virus Definitions</td><td>91.03142</td><td>Tue May  9 2023</td><td>884</td></tr>
         <tr style="background-color: #E57373; color: #ffffff;"><td>IPS Attack Engine</td><td>4.00076</td><td>Tue May  9 2023</td><td>884</td></tr>
         </tbody></table>
       </td></tr>
       <tr><td><strong>Days15&Below</strong></td><td><p>No licenses in this category.</p></td></tr>
       </tbody></table>
       <br><br><b>Attached below the Non Expiring List:</b><br><br>
       <table><thead><tr><th>Name</th><th>Version</th><th>Contract Expiry Date</th><th>DaysUntilExpiry</th></tr></thead><tbody>
       <tr><td>Modem List</td><td>0.000</td><td></td><td></td></tr>
       <tr><td>FDS Address</td><td></td><td></td><td></td></tr>
       </tbody></table>`
  }
};

const policyCreationMockResponse = {
  email: {
    subject: "Firewall Policy Creation Successful | Change Request: CHG12345",
    html: `
      <style>
        body { font-family: 'Segoe UI', sans-serif; color: #333; }
        .container { padding: 20px; border: 1px solid #dee2e6; border-radius: 8px; max-width: 800px; margin: auto; }
        h2 { color: #007bff; border-bottom: 2px solid #007bff; padding-bottom: 5px; }
        p { line-height: 1.6; }
        b { color: #111827; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; box-shadow: 0 4px 8px rgba(0,0,0,0.05); }
        th, td { padding: 12px 15px; text-align: left; border: 1px solid #dee2e6; }
        th { background-color: #007bff; color: white; }
        tr:nth-child(even) { background-color: #f8f9fa; }
        .footer { margin-top: 20px; font-size: 12px; color: #6c757d; }
      </style>
      <div class="container">
        <h2>Firewall Policy Creation Confirmation</h2>
        <p>This is an automated notification to confirm that the following firewall policy has been successfully created and deployed as per your request.</p>
        
        <p>
          <b>Change Request:</b> CHG12345<br>
          <b>Requested By:</b> demouser@neurealm.com<br>
          <b>Firewall Deployed To:</b> FW-CORP-01
        </p>

        <h3>Rule Details</h3>
        <table>
          <thead>
            <tr>
              <th>Policy ID</th>
              <th>Name</th>
              <th>Source</th>
              <th>Destination</th>
              <th>Service</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>148</td>
              <td>WebApp-to-DB-Access</td>
              <td>app_server_prod (10.1.1.50)</td>
              <td>db_server_prod (10.1.2.100)</td>
              <td>tcp/1433 (MS-SQL)</td>
              <td>Allow</td>
            </tr>
          </tbody>
        </table>
        
        <p class="footer">This change has been logged for audit purposes. Please validate connectivity and contact the Network Operations team if you experience any issues.
        <br>Thank you,<br><b>RunOps AI Automation Agent</b>
        </p>
      </div>
    `
  }
};



const WorkflowRunner = ({ webhookUrl, agentName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseHtml, setResponseHtml] = useState('');
  const [error, setError] = useState('');

  const isEnabled = !!webhookUrl;

  const handleTriggerWorkflow = async () => {
    setIsLoading(true);
    setResponseHtml('');
    setError('');

    // --- 2. Add a special check for the 'Firewall Policy Hygiene Agent' ---
    if (agentName === 'Firewall Policy Hygiene Agent') {
      // Simulate a network delay of 2 seconds
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Set the hardcoded response and exit the function
      setResponseHtml(policyHygieneMockResponse.email.html);
      setIsLoading(false);
      return; 
    }

    if (agentName === 'Firewall LifeCycle Management') {
      // Simulate a network delay of 2 seconds
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Set the hardcoded response and exit the function
      setResponseHtml(lifeCycleMockResponse.email.html);
      setIsLoading(false);
      return; 
    }

    if (agentName === 'Firewall Policy Creation Agent') {
      await new Promise(resolve => setTimeout(resolve, 2000));
      setResponseHtml(policyCreationMockResponse.email.html);
      setIsLoading(false);
      return; 
    }
    
    // This part will now only run for OTHER agents
    try {
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ agent: agentName }),
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || `Request failed with status ${response.status}`);
      }
      
      if (responseData.email && typeof responseData.email.html === 'string') {
        setResponseHtml(responseData.email.html);
      } else {
        throw new Error("Invalid or missing 'email.html' content in the webhook response.");
      }
     
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }

  };

  return (
    <div className="workflow-runner-container">
      <h3>Live Workflow</h3>
      <p>This is a live, functional workflow. Click the button to trigger the automation.</p>
      
      <button 
        onClick={handleTriggerWorkflow} 
        disabled={!isEnabled || isLoading}
        className="trigger-button"
      >
        {isLoading ? (
          <div className="loader"></div>
        ) : (
          'Trigger Workflow'
        )}
      </button>

      {!isEnabled && (
        <p className="disabled-note">This workflow is not enabled for this agent yet.</p>
      )}

      {error && <div className="response-box error">{error}</div>}
      
      {responseHtml && (
        <div className="response-box">
          <h4>Workflow Response:</h4>
          <iframe 
            srcDoc={responseHtml} 
            className="response-iframe"
            sandbox="allow-scripts allow-same-origin"
            title="Workflow Email Response"
          ></iframe>
        </div>
      )}

      {agentName === 'Firewall Policy Hygiene Agent' && (
      <div style={{ textAlign: 'center', marginTop: '16px' }}>
        <img
          src={mergedImage}
          alt="Summary"
          style={{
            width: '100%',
            maxWidth: '1000px',
            height: 'auto',
            borderRadius: '8px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.12)'
          }}
        />
      </div>
    )}
      
     
    </div>
  );
};

export default WorkflowRunner;